import { SVGProps } from 'react';

export const KebabMenuIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="2" cy="2" r="1.5" fill="currentColor" />
      <circle cx="8" cy="2" r="1.5" fill="currentColor" />
      <circle cx="14" cy="2" r="1.5" fill="currentColor" />
    </svg>
  );
};
